import pixelizedMinimap from './pixelizedMinimap'

export default {
  pixelizedMinimap
};


/** WEBPACK FOOTER **
 ** ./src/extensions/minimaps/index.js
 **/